<template>
  <ul class="news_list">
    <!-- 自媒体只有图文、图集、视频等类型的稿件 -->
    <li v-for="item in contentList" :key="item.id">
      <!-- 图文 styleType==1 无图 -->
      <div class="news_item" v-if="item.contentType == 5 && item.styleType == 1" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 图文 styleType==2 小图 -->
      <div class="news_item news_item_small" v-else-if="item.contentType == 5 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
        <div class="news_text">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTimeStr"></span>
          </div>
        </div>
        <div class="thumbnail">
          <img :src="item.smallPicUrl" :onerror="imgLoadError(item)" v-if="!!item.smallPicUrl && item.smallPicUrl.length > 0" />
        </div>
      </div>
      <!-- 图文 styleType==3 大图 -->
      <div class="news_item news_item_big" v-else-if="item.contentType == 5 && item.styleType == 3" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <div class="news_big_img_box">
          <div class="news_big_img">
            <img :src="item.bigUrl" :onerror="imgLoadError(item)" alt="" v-if="!!item.bigUrl && item.bigUrl.length > 0" />
          </div>
        </div>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 图文 styleType==4 三图 -->
      <div class="news_item news_item_three" v-else-if="item.contentType == 5 && item.styleType == 4" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <van-row class="news_img_list" v-if="!!item.pictureUrls && item.pictureUrls.length > 0">
          <van-col span="8" v-for="(pic, i) in item.pictureUrls" :key="i">
            <div class="news_img_item">
              <div class="news_img_box">
                <img :src="pic" alt="" :onerror="imgLoadError(item)" v-if="pic.length > 0" />
              </div>
            </div>
          </van-col>
        </van-row>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 图集 styleType==1 无图 -->
      <div class="news_item" v-if="item.contentType == 6 && item.styleType == 1" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 图集 styleType==2 小图 -->
      <div class="news_item news_item_small" v-else-if="item.contentType == 6 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
        <div class="news_text">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTimeStr"></span>
          </div>
        </div>
        <div class="thumbnail">
          <img v-if="item.smallPicUrl.length > 0" :src="item.smallPicUrl" :onerror="imgLoadError(item)" />
        </div>
      </div>
      <!-- 图集 styleType==3 大图 -->
      <div class="news_item news_item_big" v-else-if="item.contentType == 6 && item.styleType == 3" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <div class="news_big_img_box">
          <div class="news_big_img">
            <img :src="item.bigUrl" :onerror="imgLoadError(item)" v-if="item.bigUrl.length > 0" alt="" />
          </div>
        </div>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 图集 styleType==4 三图 -->
      <div class="news_item news_item_three" v-else-if="item.contentType == 6 && item.styleType == 4" @click="toDetail(item)">
        <div class="news_title">
          <span v-text="item.title"></span>
        </div>
        <van-row class="news_img_list" v-if="!!item.picList && item.picList.length > 0">
          <van-col span="8" v-for="(pic, i) in item.picList" :key="i">
            <div class="news_img_item">
              <div class="news_img_box">
                <img :src="pic.url" alt="" :onerror="imgLoadError(item)" v-if="pic.url.length > 0" />
              </div>
            </div>
          </van-col>
        </van-row>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
      <!-- 视频 -->
      <div class="news_item news_item_video" v-else-if="item.contentType == 9">
        <div class="news_title" v-text="item.title" @click="toDetail(item)"></div>
        <div class="news_video_box" v-if="!!item.playInfo">
          <video :width="item.playInfo.videoWidth" :height="item.playInfo.videoHeight" :poster="item.playInfo.coverUrl" controls controlsList="nodownload" disablePictureInPicture>
            <source :src="item.playInfo.playUrl" type="video/mp4" />
          </video>
        </div>
        <div class="news_info">
          <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
          <span class="source" v-text="appName" v-else></span>
          <span class="time" v-text="item.publishTimeStr"></span>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
export default {
  name: "NewsList",
  props: {
    contentList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      newsList: [],
    };
  },
  watch: {
    contentList: {
      handler(newVal, oldVal) {
        this.newsList = deepClone(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState("app", ["appName"]),
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 稿件列表，跳转详情 */
    toDetail(item) {
      if (item.contentType == 5) {
        // 图文
        var q = {
          contentType: item.contentType,
          contentId: item.contentId,
          cId: 0,
          fromFlag: 2,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/news_detail",
          query: q,
        });
      } else if (item.contentType == 6) {
        // 图集
        var q = {
          contentType: item.contentType,
          contentId: item.contentId,
          cId: 0,
          fromFlag: 2,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/gallery_detail",
          query: q,
        });
      } else if (item.contentType == 9) {
        var q = {
          contentType: item.contentType,
          contentId: item.contentId,
          cId: 0,
          fromFlag: 2,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/video_detail",
          query: q,
        });
      }
    },
  },
  created() {
    this.newsList = deepClone(this.contentList);
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
};
</script>